import { ScheduleAPI } from '../../../api/bussched/ScheduleAPI';

export class SchedulesCommand {
    list(edition, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Horários");
            }
        });
    }

    listCarris(edition, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.listCarris(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Horários");
            }
        });
    }

    activeByLine(edition, line, referenceDate, successCallback, errorCallback) {
        const apiResult = ScheduleAPI.activeByLine(edition, line, referenceDate);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Horários");
            }
        });
    }
}
